import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";

import { CurrierCompanyService } from "../../../services/currier-company-service";

export const Curriercompanyeditcontent = (props) => {

  const { cCompanyID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await CurrierCompanyService.currierCompanyUpdate(
        cCompanyID,
        values
      );

      setSubmitLoading(true);
      notify("Currier company successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  useEffect(() => {
    CurrierCompanySearchID();
  }, []);

  const [currierCompanyInfo, setCurrierCompanyInfo] = useState({
    company: "",
    comment: "",
    additional_kg_price: "",
  });

  const CurrierCompanySearchID = async () => {
    try {
      const result = await CurrierCompanyService.currierCompanyDetailsID(cCompanyID);

      const info = {};

      const companydata = result;

      info.company = companydata.company;
      info.comment = companydata.comment;
      info.additional_kg_price = companydata.additional_kg_price;

      setCurrierCompanyInfo(info);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Currier Company</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  company: currierCompanyInfo.company,
                  comment: currierCompanyInfo.comment,
                  additional_kg_price: currierCompanyInfo.additional_kg_price,
                }}
                validationSchema={Yup.object().shape({
                  company: Yup.string().required("Required"),
                  additional_kg_price: Yup.string().required("Required"),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Company</label>
                        <div className="input-group">
                          <input
                            name="company"
                            type="text"
                            className="form-control"
                            id="companyId"
                            placeholder="Company Name"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.company}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.company && errors.company}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Comment</label>
                        <div className="input-group">
                          <input
                            name="comment"
                            type="text"
                            className="form-control"
                            id="commentid"
                            placeholder="Comment"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.comment}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.comment && errors.comment}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Additional Kg Price</label>
                        <div className="input-group">
                          <input
                            name="additional_kg_price"
                            type="text"
                            className="form-control"
                            id="additionalid"
                            placeholder="additional_kg_price"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.additional_kg_price}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.additional_kg_price && errors.additional_kg_price}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>
                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Curriercompanyeditcontent;
